<template>
  <div>
    <el-tree
      :data="selectData"
      :highlight-current="true"
      :default-expand-all="true"
      :expand-on-click-node="false"
      node-key="id"
      ref="tree"
    ></el-tree>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Qs from 'qs'
  Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      selectData: []
    }
  },
  mounted() {
    this.apigetjigoutree()
  },
  methods: {
    apigetjigoutree: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date())/1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp:timestamp,
        localfingerprint:Vue.prototype.FunGetLocalFingerprint(),
		companytype: '1'
      }
      //加上签名
      data['sign'] = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutree, Qs.stringify(data))
        .then(function (response) {
          if(response.data.Code == 200)
          {
            that.selectData = []
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  var list4 = []
                  item3.List.filter((item4, i4) => {
                    var list5 = []
                    item4.List.filter((item5, i5) => {
                      list5.push({ id: item5.Id, label: item5.Jigouname,children: ''})
                    })
                    if(list5.length == 0) list5 = '';
                    list4.push({ id: item4.Id, label: item4.Jigouname,children: list5})
                  })
                  if(list4.length == 0) list4 = '';
                  list3.push({ id: item3.Id, label: item3.Jigouname,children: list4})
                })
                if(list3.length == 0) list3 = '';
                list2.push({ id: item2.Id, label: item2.Jigouname,children: list3})
              })
              if(list2.length == 0) list2 = '';
              that.selectData.push({ id: item1.Id, label: item1.Jigouname,children: list2})
            })
            that.defaultexpandedkeys = [1,285]
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree {
  height: 350px;
  overflow-y: scroll;
}
.el-tree::-webkit-scrollbar {
  display: none;
}
</style>
